import {
  Kpi as KpiT,
  KpiQuery as KpiQueryT,
  KpiResult as KpiResultT,
  KpiResponse as KpiResponseT,
  FilterQueryDefault
} from '../shared/Contracts'

export const energyTypes = ['CONSUMPTION', 'BOUGHT', 'PRODUCTION'] as const
export type EnergyType = (typeof energyTypes)[number]

export const energyCategories = {
  CONSUMPTION: ['ELECTRICITY', 'GAS', 'STEAM', 'DISTRICT_HEATING', 'COOLING'],

  BOUGHT: ['ELECTRICITY', 'GAS', 'STEAM', 'DISTRICT_HEATING', 'COOLING'],
  PRODUCTION: ['SOLAR_ELECTRICITY']
} as const
export type EnergyCategory = (typeof energyCategories)[EnergyType][number]

export type KpiType =
  | 'ENERGY_CONSUMPTION'
  | 'ENERGY_CONSUMPTION_ELECTRICITY'
  | 'ENERGY_CONSUMPTION_GAS'
  | 'ENERGY_CONSUMPTION_STEAM'
  | 'ENERGY_CONSUMPTION_DISTRICT_HEATING'
  | 'ENERGY_CONSUMPTION_COOLING'
  | 'ENERGY_BOUGHT'
  | 'ENERGY_BOUGHT_ELECTRICITY'
  | 'ENERGY_BOUGHT_GAS'
  | 'ENERGY_BOUGHT_STEAM'
  | 'ENERGY_BOUGHT_DISTRICT_HEATING'
  | 'ENERGY_BOUGHT_COOLING'
  | 'ENERGY_PRODUCTION'
  | 'ENERGY_PRODUCTION_SOLAR_ELECTRICITY'
  | 'ENERGY_CONSUMPTION_CONSTRUCTION_ELECTRICITY'
  | 'ENERGY_CONSUMPTION_TENANT_ELECTRICITY'
  | 'ENERGY_CONSUMPTION_OVER_AREA'
  | 'ENERGY_CONSUMPTION_ELECTRICITY_OVER_AREA'
  | 'ENERGY_CONSUMPTION_GAS_OVER_AREA'
  | 'ENERGY_CONSUMPTION_STEAM_OVER_AREA'
  | 'ENERGY_CONSUMPTION_DISTRICT_HEATING_OVER_AREA'
  | 'ENERGY_CONSUMPTION_COOLING_OVER_AREA'
  | 'ENERGY_BOUGHT_OVER_AREA'
  | 'ENERGY_BOUGHT_ELECTRICITY_OVER_AREA'
  | 'ENERGY_BOUGHT_GAS_OVER_AREA'
  | 'ENERGY_BOUGHT_STEAM_OVER_AREA'
  | 'ENERGY_BOUGHT_DISTRICT_HEATING_OVER_AREA'
  | 'ENERGY_BOUGHT_COOLING_OVER_AREA'
  | 'ENERGY_PRODUCTION_OVER_AREA'
  | 'ENERGY_PRODUCTION_SOLAR_ELECTRICITY_OVER_AREA'
  | 'ENERGY_CONSUMPTION_CONSTRUCTION_ELECTRICITY_OVER_AREA'
  | 'ENERGY_CONSUMPTION_TENANT_ELECTRICITY_OVER_AREA'

export const typeToCategory: (type: KpiType) => EnergyCategory = (type) => {
  let category
  if (type.startsWith('ENERGY_CONSUMPTION_'))
    category = type.replace('ENERGY_CONSUMPTION_', '') as EnergyCategory
  if (type.startsWith('ENERGY_BOUGHT_'))
    category = type.replace('ENERGY_BOUGHT_', '') as EnergyCategory
  if (type.startsWith('ENERGY_PRODUCTION_'))
    category = type.replace('ENERGY_PRODUCTION_', '') as EnergyCategory

  if (!category) throw new Error(`Unknown energy type: ${type}`)

  return category.replace('_OVER_AREA', '') as EnergyCategory
}

export type Kpi = KpiT<KpiType, object>
export type KpiQuery = KpiQueryT<FilterQueryDefault, KpiType, object>
export type KpiResult = KpiResultT<KpiType>
export type KpiResponse = KpiResponseT<FilterQueryDefault, KpiType>

export type TimeSeriesQuery = {
  filter: FilterQueryDefault
  kpis: KpiType[]
}

export type TimeSeriesResponse = {
  startDate: string
  endDate: string
  points: TimeSeriesValue[]
}

export type TimeSeriesValue = {
  timestamp: string
  values: Record<string, number | null>
}
